import { FundoInvestimento, TipoFundoInvestimento, TipoMovimentacaoFundoInvestimento } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from "../comum/exercicio.model";
import { Orgao } from "../comum/orgao.model";

export class MovimentoFundo extends BaseResourceModel {
  constructor(
    public codigo?: number,
    public data_movimentacao?: Date,
    public qtd_cotas?: number,
    public valor_unitario_cota?: number,
    public numero_documento?: string,
    public valor_risco?: number,
    public volatilidade?: number,
    public fato_relevante?: string,
    public percentual_investido?: number,
    public resgate?: number,
    public reinvestimento?: number,
    public rendimento_periodo?: number,
    public quantidade_cotista?: number,
    public provisionamento?: number,
    public patrimonio_liquido?: number,
    public fundo?: FundoInvestimento,
    public exercicio?: Exercicio[],
    public orgao?: Orgao[],
  ) {
    super();
  }
  static converteJson(json: any): MovimentoFundo {
    return Object.assign(new MovimentoFundo(), json);
  }
}